import spinnerAnimation from "../../assets/animations/spinner-animation.json";
import { marginX, paddingX } from "./_definitionts";
const APP_CONFIGURATION = {
  config: {
    hide_register_button: true,
    timer_checkout_seconds: 0,
    // is 0 to disable the timer
    flights_checkout_timer_seconds: 900,
    hide_mobile_title_in_home: true,
    permit_open_profile_tab_in_login: true,
    hide_backed_by_in_footer: false,
    show_partner_logo: false,
    mobile_title_header_only_back_button: true,
    render_error_page_on_auth_validate: true,
    render_price_details_on_flights: false,
    errorPageConfig: {
      titleStyle: "tx-h5-medium text-neutral_black text-center",
      subtitleStyle: "tx-h6-medium text-neutral_black text-center",
      messageStyle: "tx-plg-regular text-neutral_black text-center",
      buttonVariant: "outline"
    },
    flightDisplayConfig: {
      flightTitleClass: "!tx-pmd-bold !text-neutral_black",
      dateClass: "tx-pmd-regular !text-neutral_black",
      durationClass: "tx-psm-regular !text-neutral_black",
      destinationClass: "tx-pmd-semiBold text-neutral_black",
      iataClass: "tx-pxs-semiBold text-neutral_black",
      hourClass: "tx-h6-bold text-neutral_black",
      fareClass: "tx-pxs-semiBold text-primary-main"
    },
    welcomeMessageConfig: {
      includeDiscoverTheBestOptionsText: false,
      notificationStyle: "INFO"
    },
    minPointsToAllowPurchase: 2500,
    modalConfig: {
      mobileModalAsBottomPanel: true
    },
    demo: false,
    use_priced_cards_recommendations: true,
    appName: "Banco General",
    favicon: "/general.ico",
    navigateToAccountOnAccountButtonClick: true,
    screensConfig: {
      // Standard Tailwind breakpoints (original Funbank values commented)
      "2xs": "320px",
      // Custom smallest breakpoint (unchanged)
      xs: "384px",
      // Standard Tailwind (was 360px)
      sm: "640px",
      // Standard Tailwind (was 390px)
      md: "768px",
      // Standard Tailwind (was 744px)
      "2md": "896px",
      // Custom medium-large breakpoint (was 822px)
      lg: "1100px",
      // Standard Tailwind 1024 set custom 1100
      xl: "1280px",
      // Standard Tailwind (was 1600px)
      "2xl": "1536px",
      // Standard Tailwind (was 1920px)
      "3xl": "2560px"
    },
    contentMaxWidthConfig: [{
      config: {
        _default: "1060px"
        // md: "1700px",
      },
      property: "maxWidth"
    }],
    notificationAbsolutePosition: {
      mobileSize: "68px",
      desktopSize: "60px"
    },
    headerDynamicStyleConfig: [{
      config: {
        _default: "68px",
        sm: "68px",
        md: "60px"
      },
      property: "height"
    }, {
      config: {
        _default: "68px",
        sm: "68px",
        md: "60px"
      },
      property: "minHeight"
    }, {
      config: {
        _default: "68px",
        sm: "68px",
        md: "60px"
      },
      property: "maxHeight"
    }, {
      config: {
        _default: "24px",
        sm: "24px",
        lg: "150px"
      },
      property: "paddingLeft"
    }, {
      config: {
        _default: "24px",
        sm: "24px",
        lg: "150px"
      },
      property: "paddingRight"
    }],
    globalHorizontalPaddingConfig: [...paddingX({
      _default: "24px",
      lg: "0px"
    })],
    globalMarginConfig: [...marginX({
      _default: "auto"
    })],
    flightPaddingConfig: [...paddingX({
      _default: "22px",
      lg: "0px"
    })],
    globalCardConfig: 'rounded-xl bg-white shadow-shadow_1',
    reservationCardConfig: 'global-card rounded-2xl py-4 px-4 flex flex-row justify-between shadow-shadow_1',
    flightConfig: {
      headerConfig: 'max-h-[56px] min-h-[56px] md:max-h-[60px] md:min-h-[60px]',
      editIconSize: {
        mobileSize: '20px',
        desktopSize: '25px'
      },
      closeIconSize: {
        mobileSize: '24px',
        desktopSize: '30px'
      }
    },
    showLogoInSmallDisplay: true,
    triplePricing: false,
    pointsProviderName: 'estrellas',
    pointsCurrency: "estrellas",
    pointsCurrencyShort: "estrellas",
    cardBankProvider: "General",
    passportRegex: /[A-Z]{1,2}[0-9]{6,9}/,
    nationalIdRegex: /^\d{9}$/,
    dateFormat: "DD/MM/YYYY",
    outputDateFormat: "YYYY/MM/DD",
    defaultCountryISO2: "PA",
    defaultCountryISO3: "PAN",
    appComponents: {
      carousel: "shopstar_v2",
      carouselVariation: "banner_C",
      tabButtons: "tab_B",
      tabButtonsInProfile: "tab_B",
      tabButtonsInMyBookings: "tab_B",
      tabButtonsInBaggage: "tab_B",
      slider: "slider_B",
      filterChips: "type-b",
      creditCardsTable: "banco_general",
      carouselC_config: {
        wowColor: "#EC0046",
        wowChipClass: "tx-plg-semiBold italic font-bold",
        titleClass: "tx-h2-semiBold text-white text-left ",
        subTitleClass: "tx-h6-regular text-white text-left ",
        textWidth: 461
      }
    },
    appFooter: "bancogral",
    appHomeCarousel: "shopstar_v2",
    appHomeCarouselVariation: "banner_C",
    appLandingPage: "bancogral",
    appLogoHeight: 28,
    appLogoHeightMobil: 39,
    minAgeCarRental: 25,
    maxAgeCarRental: 120,
    font: "Inter",
    contactInformation: {
      phoneNumber: "+507 8338792",
      cancelationsPhoneNumber: "+507 8338792",
      bankPhoneNumber: "+507 300-5000",
      email: "soporte@viajes-programaestrellas.bgeneral.com",
      links: {
        facebook: "",
        instagram: "",
        reclamationBook: ""
      }
    },
    biddingCurveConfig: "ONLY_CASH_END",
    curveStartingPosition: "MIDDLE",
    profileRequiredFields: {
      name: true,
      lastName: true,
      country: true,
      state: true,
      city: true,
      address: true,
      phoneNumber: true,
      birthDate: true,
      maritalStatus: true,
      postalCode: true,
      gender: true
    },
    priceCombinationName: "estrellas",
    showLogoInCombiationPrice: false,
    price_classes: {
      text_combination_class: "tx-psm-regular text-neutral_black",
      text_combiantions_container_class: 'flex flex-col'
    },
    saveUserSearches: true,
    priceUseSlider: {
      flights: {
        selectFlight: false,
        selectFare: false,
        itenerary: true,
        passengers: true,
        checkout: true
      },
      cars: {
        selectCar: false,
        carDetails: true,
        driver: true,
        checkout: true
      },
      hotels: {
        selectHotel: false,
        selectRoom: true,
        guests: true,
        checkout: true
      },
      insurances: {
        selectInsurance: true,
        passengers: true,
        checkout: true
      }
    },
    showPointsLogoInPrice: false,
    curveInPaymentMethod: false,
    fare_family_config: {
      topBorderTypes: ["INCLUDED"],
      borderTypes: ["INCLUDED"],
      titleTypes: ["INCLUDED"],
      fareTitlesTypes: ["INCLUDED"],
      titleFontColor: "#004C97",
      specsFontColor: "#000",
      buttonColor: "#004C97"
    },
    spinnerAnimation: spinnerAnimation,
    spinnerColor: '#004C97',
    forms: {
      borderRadius: '8px',
      height: '40px',
      padding: '8px 14px',
      leftOnLabel: '12px',
      buttons_Radius: "rounded-xl",
      buttons_height: "!h-[148px]",
      radio_first: true,
      radio_button_home: "xl",
      radio_button_data: 'base',
      autocomplete_popup_indicator: false,
      select_arrow_size: 15,
      sort_chevron_color: "#5C5C5C",
      // CODE
      sort_text_class: "tx-psm-regular text-gray_medium",
      select_arrow_color: "#1677D8",
      card_title_class: "tx-pmd-medium text-neutral_black",
      frequent_flyer_icon_size: 18,
      frequent_flyer_icon_class: "text-primary_text",
      frequent_flyer_icon: "airplaneFillTop",
      search_input_class: "!tx-pmd-regular !text-[#6F7583]",
      buttons_text_class: "tx-pmd-semiBold",
      form_builder: {
        section_title_class: "tx-pmd-regular text-[#292E38]",
        label_class: "tx-pmd-regular text-[#292E38]",
        sub_label_class: "tx-psm-regular text-[#292E38]",
        input_class: "tx-psm-regular text-input_text_color",
        description_class: "tx-pxs-regular text-neutral-500",
        radio_button_text_class: "tx-pmd-regular text-neutral_black",
        checkbox_text_class: "tx-pmd-regular text-neutral_black"
      }
    },
    use_cards_border: false,
    cards_border_color: "#5C5C5C",
    buttonsConfig: {
      extra_small: {
        paddingX: "16px",
        paddingY: "8px",
        minHeight: "47px",
        minWidth: "107px"
      },
      small: {
        paddingX: "16px",
        paddingY: "8px",
        minHeight: "47px",
        minWidth: "120px"
      },
      medium: {
        paddingX: "32px",
        paddingY: "8px",
        minHeight: "47px",
        minWidth: "140px"
      },
      large: {
        paddingX: "64px",
        paddingY: "8px",
        minHeight: "47px",
        minWidth: "160px"
      },
      full: {
        paddingX: "16px",
        paddingY: "8px",
        minHeight: "47px",
        minWidth: "100%"
      }
    },
    inputsIconSize: 16,
    autoCompleteGroupIconSize: 20,
    autoCompleteOptionsIconSize: 20,
    useSearhAnimationInResources: true,
    addEntityLogoInLoadingAnimation: true,
    usePlatformLogoInLoadingAnimation: false,
    // NEED addEntityLogoInLoadingAnimation TRUE
    heightEntityLogoInLoadingAnimation_md: 48,
    heightEntityLogoInLoadingAnimation_sm: 48,
    widthEntityLogoInLoadingAnimation_md: 240,
    widthEntityLogoInLoadingAnimation_sm: 240,
    resourcesAnimationHeight: 120,
    loadingSearchAnimationHeight: 120,
    header_currency_size: 16,
    headerFlightsConfig: {
      headerIconSize: isMobile => isMobile ? 18 : 20,
      personIconClass: 'w-4 h-4 md:w-5 md:h-5',
      starIconClass: 'w-4 h-4 md:w-5 md:h-5',
      openSearchIconClass: 'w-5 h-5 md:w-[30px] md:h-[30px]',
      closeSearchIconClass: 'w-5 h-5 md:w-10 md:h-10'
    },
    loginUseContrastIcon: true,
    loginPlatformLogoHeight: 35,
    priceEntityLogoClasess: {
      hotelsRoomCard: "62px",
      checkoutPayment: "71px"
    },
    notificationStyleConfig: {
      success: "bg-success-main text-white",
      error: "bg-error-main text-white",
      warning: "bg-warning-main text-white",
      info: "bg-tertiary_a-main text-tertiary_b-main"
    },
    productRecommendationConfig: {
      discountTag: "bg-tertiary_b-main text-white border-2 border-white",
      serviceTypeTag: "bg-tertiary_a-main text-primary-main rounded-xl",
      pointsPriceText: "tx-h5-semiBold md:tx-h6-semiBold text-secondary-main text-start",
      cashPriceText: "tx-pmd-regular text-secondary-main  text-start",
      titleText: "text-neutral_black",
      itemText: "tx-psm-regular text-neutral_black",
      filterTagSelected: "tx-pmd-bold text-primary-main bg-[#E1E4FF]",
      filterTagUnselected: "hover:border-primary-main",
      filterTagBase: 'tx-pmd-regular text-[#6F7583] filter flex items-center gap-2 py-2 px-3 bg-white card-shadow global-card  rounded-full',
      mobileScrollArrows: 'text-primary-main tx-pmd-regular',
      productIconColor: "#004C97",
      priceTitle: "tx-psm-regular text-gray_medium"
    },
    tripSummaryConfig: {
      title: "tx-h6-regular",
      subtitle: "tx-pmd-regular"
    },
    flights_summary_config: {
      flight_type_class_sm: "tx-pmd-semiBold text-neutral_black",
      flight_type_class_md: "tx-psm-semiBold text-neutral_black",
      date_time_class: "tx-pmd-regular md:tx-pxs-regular text-neutral_black",
      aiport_class: "tx-psm-regular md:tx-pxs-regular text-neutral_black",
      passengers_title_class_sm: "tx-pmd-semiBold text-neutral_black",
      passengers_title_class_md: "tx-pmd-semiBold text-neutral_black",
      passengers_value_class: "tx-pmd-regular md:tx-pxs-regular text-neutral_black",
      baggage_title_class_sm: "tx-pmd-semiBold text-neutral_black",
      baggage_title_class_md: "tx-pmd-semiBold text-neutral_black",
      baggage_subtitle_class_sm: "tx-pmd-semiBold text-neutral_black",
      baggage_subtitle_class_md: "tx-pmd-semiBold text-neutral_black",
      baggage_detail_class_sm: "tx-pmd-regular text-neutral_black",
      baggage_detail_class_md: "tx-pmd-regular text-neutral_black",
      baggage_tabSelected_class: "bg-secondary-main text-white rounded-md tx-pmd-semiBold",
      baggage_tabUnselected_class: "bg-white text-gray_medium  rounded-md tx-pmd-regular shadow-md"
    },
    allowRefreshPoints: true,
    subTitle_cardsModal: true,
    header_row_points_display: true,
    profile_sections: {
      show_personal_info: false,
      show_favorite_passengers: true,
      show_credit_cards: true,
      show_bookings: true,
      add_card_form_hide_email_and_dni_input: true
    },
    add_card_name_in_add_card_button: false,
    messages_modal: {
      title_class: 'tx-h6-medium text-neutral_black',
      message_class: "tx-pmd-regular text-neutral_black"
    },
    favorite_data_config: {
      edit_icons_size: 16,
      edit_icons_color: "#1677D8",
      chevron_icon_class: 'w-[22px] h-[22px] text-primary-main',
      add_button_class: 'tx-pmd-semiBold text-primary-main',
      add_button_filled: true,
      title_class: 'tx-pmd-semiBold text-neutral_black',
      subtitle_class: 'tx-pmd-medium text-neutral_black',
      value_class: 'tx-pmd-regular text-neutral_black',
      favorite_icon_class: 'w-[20px] h-[20px] text-neutral_black',
      form_buttons_color: "#1677D8" // CODE
    },
    header: {
      header_action_buttons_class: "tx-pxxs-semiBold md:!tx-pmd-semiBold"
    },
    checkout_timer: {
      message_class: "tx-pmd-regular md:tx-plg-regular",
      timer_class: "tx-plg-semiBold md:tx-h6-semiBold"
    },
    entity_points_pay_loader: {
      message_class_md: "tx-h6-regular",
      message_class_sm: "tx-pmd-regular",
      progress_bar_color: "#FF6D18",
      progress_bar_border_color: "#FF6D18",
      progress_bar_height: 18,
      progress_bar_border_radius: 20
    },
    maintenance: {
      // TODO UPDATE FROM FIGMA
      bg_color: "bg-primary-main",
      title_md: "text-[40px] text-secondary-main font-bold",
      title_sm: "tx-h3-semiBold text-secondary-main",
      description_md: "tx-psm-regular text-white",
      description_sm: "tx-pmd-regular text-white",
      support_items_md: "tx-psm-regular text-white",
      support_items_sm: "tx-plg-regular text-white",
      description_warning_md: "",
      description_warning_sm: ""
    },
    transition: {
      bg_color: "bg-white",
      title_md: "tx-h1-semiBold text-secondary-main",
      title_sm: "tx-h3-semiBold text-secondary-main",
      description_md: "tx-psm-regular text-primary-main",
      description_sm: "tx-pmd-regular text-primary-main",
      support_items_md: "",
      support_items_sm: "",
      description_warning_md: "tx-pmd-semiBold text-primary-main",
      description_warning_sm: "tx-pmd-semiBold text-primary-main"
    },
    rich_message_config: {
      text_style: "text-left",
      links_style: "text-secondary-main",
      bold_style: "text-secondary-main"
    }
  },
  colors: {
    general: {
      primary: "#1677D8",
      secondary: "#004C97",
      tertiary: "#E1F0FF",
      accents: "#FF6D18",
      special_offer: "#14A1FF",
      wow_offer: "#EC0046",
      general_text: "#292E38",
      background: "#F7F9FC",
      cards_background: "#FFFFFF",
      hovers: "#1677D81A",
      dividers: "#D2D6DE",
      disclaimers: "#D2D6DE",
      success: "#009950",
      error: "#D0021B",
      warning: "#F59E0B",
      gray: "#6F7583",
      open_modal_text: "#1677D8",
      frequent_flyer_icon: "#292E38",
      icons: {
        general: "#292E38",
        payment_available_points: "#009950",
        frequent_flyer: "#292E38"
      }
    },
    // ----------------------------
    // Global Components
    globals: {
      radio_buttons: "#1677D8",
      radio_buttons_default_color: "#6F7583",
      tooltip: {
        background: "#676A6ACC",
        text: "#FFFFFF"
      },
      loading_animation: "#1677D8",
      app_background: "#F7F9FC",
      open_modal_color: "#1677D8",
      modal_title: "#292E38",
      modal: {
        modal_title_class: "!tx-h6-medium font-medium text-neutral_black",
        modal_description_class: "tx-pmd-regular text-neutral_black",
        modal_actions_class: "flex flex-col md:flex-row gap-4"
      },
      modal_close_button_light: "#FFFFFF",
      modal_close_button_dark: "#5C5C5C",
      success_page_title: "#1677D8",
      chips_selected_filters: "#1677D8",
      buttons: {
        selectButton: "#1677D8",
        actionButton: "#1677D8",
        secondary_actionButton: "#1677D8"
      },
      filters_divider: "#D2D6DE",
      filtersSlider: {
        thumb: "#FFFFFF",
        track: "#1677D8",
        text: "#292E38",
        track_height: 8,
        track_background: "#9FA6B7"
      },
      tabs: {
        tabSelected: "bg-primary-main text-white rounded-full",
        tabUnselected: "bg-white text-primary_text shadow-md rounded-full"
      },
      paymentSlider: {
        track: '#FF6D18',
        rail_border: "#D2D6DE",
        rail_background: '#EBEEF4',
        thumb_color: "#FF6D18",
        thumb_background: '#fff'
      },
      calendar: {
        select_color: "#004C97",
        select_color_20: "#004C9733"
      },
      filter_chips: {
        icon_color: "#1677D8",
        border_color: "none",
        text_color: "#1677D8",
        clear_all_bg_color: "#1677D8",
        bg_color: "#FFFFFF"
      },
      steps: {
        step_circles_active: "#1677D8",
        step_circle_border_unselected_color: '#E3E7F0',
        step_circle_text_unselected_color: "#292E38",
        step_circle_label_selected_class: "tx-pmd-semiBold",
        step_circle_label_unselected_class: "tx-pmd-regular",
        step_circle_number_selected_class_sm: "tx-pmd-semiBold",
        step_circle_number_selected_class_md: "tx-h6-semiBold",
        step_circle_number_unselected_class_sm: "tx-pmd-regular",
        step_circle_number_unselected_class_md: "tx-h6-regular"
      },
      search_header: "#1677D8",
      offer: "#EC0046",
      discount: "#14A1FF",
      bg_search_header: "#E1F0FF",
      text_search_header: "#004C97",
      icons_search_header: "#004C97",
      neutral_black: "#292E38",
      input_border: "#D2D6DE",
      input_text: "#6F7583",
      input_icon: "#6F7583",
      check: "#009950",
      autocomplete_hover_option: "#E1F0FF",
      filter_panel: {
        exit_icon: 'w-[22px] h-[22px]',
        exit_icon_color: "text-gray_medium",
        title_panel: "tx-pmd-medium text-neutral_black",
        clear_text: 'tx-pmd-semiBold text-primary-main',
        order_by_title: '!tx-psm-regular text-neutral_black',
        order_by_selected_value: '!tx-pmd-semiBold text-neutral_black',
        title_filters: 'tx-h6-medium text-neutral_black',
        arrow_filters: 'text-primary-main',
        clear_selected_filters: '!tx-pmd-semiBold  !text-[#9FA6B7]',
        check_box_base: "w-4 h-4",
        chec_box_base_color: "#9FA6B7",
        check_box_checked: "#1677D8",
        clear_icon_color_disabled: "#9FA6B7",
        clear_icon_color_enabled: "#1677D8",
        show_trash_icon: true,
        see_more_filters_color: "#1677D8",
        see_more_filters_sm: "tx-psm-semiBold h-5 mt-4",
        see_more_filters_md: "tx-pxs-semiBold h-5 mt-4"
      },
      special_price_color: "#004C97",
      price_cash_color: "#004C97",
      // CODE
      price_points_color: "#004C97",
      // CODE
      price_points_class: "tx-h6-semiBold text-secondary-main",
      price_cash_class: "tx-h6-semiBold text-primary-main",
      price_card_cash_class: "tx-h6-semiBold text-primary-main",
      price_card_points_class: "tx-h6-semiBold text-secondary-main",
      triple_pricing_class_sm: "tx-pmd-semiBold",
      regular_price_class_md: "tx-psm-semiBold",
      fallback_display: {
        container_class: "global-card rounded-2xl",
        title_class: "tx-h6-semiBold text-tertiary_b-main",
        message_class: "tx-pmd-regular text-neutral_black"
      },
      dot_path_line: {
        icon_color: "#292E38",
        line_color: "#1677D8"
      },
      back_button_color: "#0039A6"
    },
    resume: {
      details_title: "tx-pmd-semiBold text-neutral_black",
      details_text: "tx-pmd-regular text-neutral_black"
    },
    add_card_form: {
      title: 'tx-h6-medium text-neutral_black mb-4',
      subtitle: 'hidden',
      input_labels: 'tx-pmd-regular text-neutral_black',
      inputs_descriptions: 'tx-pxs-regular text-gray_medium',
      inputs_error_messages: 'tx-pxs-light text-error-main',
      set_default_checkbox_text: 'tx-pmd-regular text-neutral_black',
      terms_and_conditions_container: 'hidden',
      terms_and_conditions_text: 'tx-pmd-regular text-neutral_black',
      buttons_container: '!mt-[70px]',
      auto_complete_checkbox: 'tx-psm-semiBold text-primary-main'
    },
    // ----------------------------

    //Landing Components
    landing: {
      primary: "#1677D8",
      secondary: "#234168",
      carousel_title: "#ffffff",
      loader_description_text: "tx-pmd-regular text-neutral_black"
    },
    // ----------------------------

    //Header Components
    header: {
      primary_main: "linear-gradient(180deg, #004C97 0%, #1677D8 100%)",
      secondary_main: "transparent",
      default_text: "#3F4040",
      account_icon: "#FFFFFF",
      login_button: "#1677D8",
      register_button: "#234168",
      register_button_text: "#FFFFFF",
      points_text_class: "tx-psm-semiBold"
    },
    // ----------------------------

    //Footer Components
    footer: {
      primary_main: "#F7F9FC",
      secondary_main: "#234168",
      appFooterClass: "bg-footer-primary lg:bg-footer-secondary",
      text_color: "#0039A6"
    },
    // ----------------------------

    //Home Components
    home: {
      selectors: "#1677D8",
      selectors_text: "tx-psm-bold",
      search_flight_passenger_icon: 'personIconFilled',
      search_flight_cabin_icon: 'star',
      buttons: "#1677D8",
      titles: "#292E38",
      recommendations_label: "#1677D8",
      recommendations_title: "#234168",
      button_icon_class: "text-primary-main",
      recommendations_bg: "white",
      nav_card_tabs_unselected: "#292E38",
      // CODE TABS UNSELECTED
      nav_card_tabs: "#1677D8",
      // CODE SELECTED TAB
      search_buttom: "#1677D8",
      reseent_searches_title: "1677D8",
      last_searches: "#1677D8",
      last_searches_title: "#292E38",
      last_searches_details: "#292E38"
    },
    // ----------------------------

    //Flights Flow Components
    flights: {
      itenerary_baggage_details: {
        title_class: 'tx-h6-medium text-primary-main md:tx-pmd-semiBold',
        subtitle_class_sm: 'tx-pmd-semiBold text-neutral_black',
        subtitle_class_md: 'tx-psm-semiBold text-neutral_black'
      },
      search_bar: "#1677D8",
      step_circles: "#1677D8",
      select_flight_title_class: "tx-h6-medium",
      select_flight_title: "#292E38",
      select_flight_description_class: "tx-h6-medium  lg:tx-psm-medium",
      select_flight_text: "#5C5C5C",
      cabin_selector_title: "#1677D8",
      see_details_button: "#1677D8",
      see_details_button_class: "tx-pxs-semiBold text-primary-main",
      flight_card: {
        flight_type_chip: "#234168",
        flight_card_button: "#1677D8",
        details_modal_title: "#292E38",
        details_modal_subtitles: "#292E38",
        details_modal_date_time: "#292E38",
        details_modal_scale_title: "#292E38",
        scale_detail: "#E1F0FF"
      },
      filters: {
        filter_title: "#234168",
        filter_type_subtitle: "#292E38",
        time_filter_tab: "#1677D8",
        slider_thumbs: "#1677D8",
        slider_track: "#234168",
        slider_text: "#234168"
      },
      flight_detail_button: "#5C5C5C",
      // --- Fare families
      fare_family: {
        INCLUDED: {
          color: "#004C97",
          topBorderColor: "#004C97"
        },
        UP: {
          color: "#E1F0FF",
          fontColor: "#004C97"
        },
        DOWN: {
          color: "#9FA6B7"
        },
        BEST: {
          color: "#004C97"
        },
        details: "text-neutral_black tx-pxs-regular",
        select_fare_title: 'tx-plg-medium text-neutral_black',
        select_fare_subTitle: 'tx-pmd-regular text-[#6F7583]',
        fare_sub_type: 'tx-psm-medium',
        fare_sub_type_container: 'w-[90%] rounded-lg',
        sub_groups: "tx-psm-semiBold text-neutral_black",
        details_accordion_title_sm: "tx-plg-medium text-neutral_black",
        details_accordion_title_md: "tx-psm-medium text-neutral_black",
        details_accordion_icon: "text-primary-main h-4 w-4",
        details_accordion_text: 'tx-pmd-regular text-neutral_black',
        details_accordion_link: 'tx-pmd-semiBold text-neutral_black',
        fare_itenerary_class: 'tx-pxs-semiBold text-primary-main',
        location_itenerary_class: 'tx-pmd-semiBold text-primary-main'
      },
      // --- Fare families
      itinerary: {
        details_button: "#4F4F4F",
        titles: "#292E38",
        details_color: "#292E38",
        details_title_class: 'tx-pmd-regular',
        details_text_class: 'tx-psm-bold'
      },
      summary: {
        trip_title: "#000",
        segment_title: "#000",
        type_destination_title: "#000",
        passengers_title: "#000",
        baggage_title: "#000",
        segment_index_title: "#000",
        total_title: "#000"
      },
      form: {
        disclaimer_background: "#F3F3F3",
        disclaimer_text: "#3F4040",
        passenger_index_title: "#5C5C5C",
        input_labels: "#5C5C5C"
      },
      calendar_tabs: {
        selected: {
          container: "bg-primary-500 border-primary-500",
          cash_text: "text-white",
          points_text: "text-white",
          date_text: "text-white",
          icon_color: "white"
        },
        unselected: {
          container: "bg-white border-transparent",
          cash_text: "text-gray_medium",
          points_text: "text-neutral_black",
          date_text: "text-gray_medium",
          icon_color: "black"
        },
        iconSize: 12
      },
      select_flight: {
        type_text: "#4F4F4F",
        type_bg: "#E1F0FF",
        type_icon: "#004C97",
        data: "#292E38"
      },
      booking: {
        status_title_class: 'tx-h6-medium text-neutral_black',
        date_title_class: 'tx-pmd-regular text-neutral_black',
        detail_title_class: 'tx-plg-semiBold text-neutral_black',
        detail_text_class: 'tx-pmd-regular text-neutral_black',
        details_subTitle_class: 'tx-pmd-semiBold text-neutral_black',
        ancillary_title_class: 'tx-pmd-semiBold text-gray_medium',
        ancillary_detail_class: 'tx-pmd-regular text-neutral_black',
        important_text_class: 'tx-pmd-regular text-neutral_black',
        important_text_value_class: 'tx-pmd-semiBold text-neutral_black',
        price_title_class: '!tx-h6-medium !text-neutral_black',
        price_text_class: '!tx-pmd-regular !text-neutral_black',
        price_cash_class: '!tx-h5-medium !text-globals-special_price_color',
        price_points_class: '!tx-h5-semiBold !text-globals-special_price_color'
      },
      details_modal: {
        title_flight_class: "tx-plg-semiBold md:tx-pmd-medium text-neutral_black",
        date_time_class: "tx-plg-medium  md:tx-pmd-medium text-neutral_black",
        airport_class: "tx-pmd-regular  md:tx-psm-regular text-gray_medium",
        plane_model_title_class: "tx-pmd-semiBold  md:tx-psm-semiBold text-neutral_black",
        plane_model_value_class: "tx-psm-regular  md:tx-psm-regular text-neutral_black",
        plane_model_disclaimer_class: "tx-psm-regular  md:tx-pxs-regular text-gray_medium"
      },
      load_more_button_config: {
        container_class: "flex flex-row justify-start items-center w-full",
        text_class: "tx-plg-semiBold h-fit px-8",
        show_icon: true,
        variant: "link"
      }
    },
    // ----------------------------

    //Hotel Flow Components
    hotels: {
      hotel_card: {
        hotel_name: "#234168",
        hotel_address: "#5C5C5C",
        accommodation_type_chip: "#1677D8",
        star_rating: "#FAB600",
        amenity_chip: "#234168"
      },
      filters: {
        star_rating: "#1677D8"
      },
      detail: {
        hotel_name: "#234168",
        hotel_address: "#5C5C5C",
        hotel_description_title: "#1677D8",
        description_see_more_button: "#234168",
        hotel_details_title: "#1677D8",
        rooms_section_title: "#292E38",
        map_title: "#1677D8",
        location_icon: "#1677D8",
        phone_icon: "#0F191EF1",
        amenities_icon: "#0F191EF1",
        modal: {
          title: "#234168",
          subtitle: "#1677D8",
          tertiaryTitle: "#1677D8",
          item_value: "#0F191EF1"
        },
        rooms: {
          room_name: "#1677D8",
          text_color: "#0F191EF1",
          icons_color: "#0F191E",
          icons_size: 16,
          person_icon: 'personIconRound',
          modal: {
            title: "#1677D8",
            subtitles: "#1677D8",
            text_color: "#0F191EF1",
            icons_color: "#0F191E",
            chevron_color: "#0F191EF1",
            icons_size: 20
          }
        }
      },
      form: {
        disclaimer_background: "#F3F3F3",
        main_contact_title: "#4F4F4F",
        disclaimer_text: "#5C5C5C",
        input_labels: "#5C5C5C"
      },
      summary: {
        title: "#1677D8",
        subtitles: "#1677D8",
        terms_and_conditions: "#5C5C5C",
        resume_subtitles: "#1677D8",
        resume_icons: "#1677D8"
      },
      map: {
        title: "#1677D8",
        button: "#1677D8",
        card_title: "#1677D8"
      }
    },
    // ----------------------------

    //Car Flow Components
    cars: {
      security_deposit_disclaimer: "#1677D8",
      car_card: {
        car_name: "#234168",
        location_details_title: "#234168"
      },
      details: {
        location_details_title: "#234168",
        rate_detail_title: "#234168",
        terms_and_conditions: "#1677D8"
      },
      form: {
        main_contact_title: "#1677D8",
        disclaimer_text: "#5C5C5C",
        input_labels: "#5C5C5C"
      },
      total_title: "#234168",
      bg_security_deposit: "#1677D8",
      bg_security_deposit_opacity: "0.2",
      security_deposit_border_color: '#1677D8',
      security_deposit_text_color: "#1677D8"
    },
    // ----------------------------

    //Checkout Template Screen Components
    checkout: {
      price_card_background: "#E1F0FF",
      steps_title_color: "#292E38",
      autocomplete_data_check: "#1677D8",
      points_available_use_card: false,
      points_available: "#292E38",
      points_available_icon: "#009950",
      points_to_use: "#292E38",
      points_to_use_title: "#292E38",
      points_balance: "#292E38",
      points_balance_title: "#292E38",
      step_circle_text: "#004C97",
      step_circles: "#E1F0FF",
      links_disclaimer: "#1677D8",
      total_title_class: 'tx-pmd-semiBold text-primary-main',
      title_class: 'tx-h6-medium text-neutral_black',
      subtitle_class: 'tx-pmd-regular text-neutral_black',
      finish_purchase_title: 'text-checkout-steps_title_color tx-plg-semiBold md:tx-h6-semiBold',
      finish_purchase_subtitle: 'text-gray_medium tx-pmd-regular md:tx-psm-regular'
    },
    // ----------------------------

    //Profile Components
    profile: {
      user_icon: "#E1F0FF",
      user_letter: "#004C97",
      personal_information: {
        user_greetings_class: "tx-h5-medium text-neutral_black",
        user_points_text_class: 'tx-pmd-regular text-neutral_black',
        user_points_class: 'tx-pmd-bold text-neutral_black',
        user_greeting_text: "#292E38",
        input_labels: "#5C5C5C",
        change_password_button: "#234168"
      },
      cards: {
        cards_title: "#000",
        card_title_class: "tx-h6-medium text-neutral_black",
        cards_header: "flex flex-row items-center rounded-xl border border-neutral-600 shadow-md gap-8 p-11",
        table_title: "tx-pxs-regular text-neutral-500",
        table_text: "tx-psm-regular text-neutral-500",
        delete_card_button: "#DC2626",
        show_entity_logo: false,
        container_card: 'global-card rounded-2xl py-4 px-8 flex flex-row justify-between',
        hide_card_name: true
      },
      reservations: {
        reservation_status_title: "tx-h6-medium text-neutral_black",
        flights: {
          trip_title: "#292E38",
          trip_index_subtitle: "#292E38",
          trip_title_class: "tx-pmd-semiBold text-primary-main",
          trip_fare_class: "tx-pxs-regular text-gray_medium",
          flight_type_class: "tx-psm-semiBold text-primary-main",
          flight_details_class: "tx-pxs-regular text-gray_medium",
          see_details_button: "#05BE50",
          add_baggage_button: "#0039A6",
          flight_detail: {
            title: "#292E38",
            date_title: "#292E38",
            subtitle: "#292E38",
            details_class: 'tx-pmd-medium text-neutral_black',
            price_title_class: 'tx-pmd-regular text-neutral_black'
          }
        },
        hotels: {
          hotel_title: "#000",
          hotel_title_class: "tx-pmd-semiBold text-primary-main",
          hotel_address_class: "tx-pxs-regular text-gray_medium",
          hotel_detail: {
            title: "#000",
            subtitle: "#000"
          }
        },
        cars: {
          car_detail: {
            title: "#000",
            subtitle: "#000"
          }
        }
      },
      bookings_tab_buttons: "#1677D8",
      sections_menu: {
        color_sm: "#1677D8",
        color_md: "#676A6A",
        icon_size_sm: 24,
        icon_size_md: 20
      },
      add_additional_baggage: {
        title_class: "tx-h6-medium text-neutral_black",
        subtitle_class: "tx-pmd-regular text-neutral_black",
        flight_title_tab_base_class: "tx-h6-semiBold",
        flight_title_active_tab_class: "text-primary_main",
        flight_title_tab_class: "text-neutral_black",
        flight_subtitle_tab_base_class: "tx-h6-semiBold",
        actual_baggage_title_class: "tx-plg-semiBold text-neutral_black",
        actual_baggage_subtitle_class: "tx-pmd-semiBold text-neutral_black",
        actual_baggage_details_class: "tx-pmd-regular text-neutral_black",
        passenger_title_class: "tx-plg-semiBold text-neutral_black",
        passenger_subtitle_class: "tx-pmd-medium text-neutral_black",
        check_title_class: "tx-pmd-semiBold text-neutral_black",
        check_subtitle_class: "tx-pmd-medium text-neutral_black",
        price_cash_class: "tx-pmd-medium text-neutral_black",
        price_points_class: "tx-pmd-semiBold text-neutral_black",
        disabled_text_class: "text-gray_medium",
        price_total_titleclass: "!tx-h6-medium !text-neutral_black sm:!tx-h6-medium",
        price_points_total_class: 'tx-h5-semiBold text-neutral_black sm:tx-h5-semiBold',
        price_cash_total_class: "tx-h5-medium text-neutral_black sm:tx-h5-medium",
        tax_title_class: "!tx-pmd-regular !text-gray_medium",
        resumen_icon_size: 16,
        resumen_icon_color: "#1677D8",
        resumen_title_class: "tx-plg-semiBold text-neutral_black",
        resumen_subtitle_class: "tx-pmd-medium text-neutral_black",
        check_box_color: "#04BF93"
      },
      md_profilesections_show_icons: false,
      md_profile_sections_products_to_center: true
    },
    // ----------------------------

    confirmation: {
      code_background: "none",
      code_text_color: "#000000",
      to_home_button_type: 'outlineXL',
      confirmation_title_class: 'tx-h4-semiBold text-primary-main',
      confimation_code_text_class: 'tx-psm_semiBold text-gray_medium',
      confirmation_code_class: 'tx-pmd-semiBold text-primary-main',
      email_text_class: 'tx-psm-regular text-neutral_black',
      email_text__link_class: 'tx-psm-semiBold text-neutral_black',
      recommendations_title_class: 'tx-h6-semiBold text-primary-main',
      recommendations_subtitle_class: 'tx-psm-regular text-neutral_black',
      recommendations_type_title_class: 'tx-pmd-semiBold text-primary-main',
      resend_email_title_class: 'tx-h6-semiBold text-primary-main',
      resend_emai_description_class: 'tx-psm-regular text-gray_medium',
      resend_email_button_type: 'outlineXL'
    },
    //Points & Cash Components
    points_branding: "#292E38",
    cash_branding: "#292E38",
    // ----------------------------

    primary_text: "#6F7583",
    secondary_text: "#9FA6B7",
    // primary
    primary_main: "#1677D8",
    primary_50: "#DCEEFD",
    primary_100: "#B2E0FF",
    primary_200: "#7DCFFF",
    primary_300: "#40B2FF",
    primary_400: "#148DFF",
    primary_500: "#1677D8",
    primary_600: "#0050FF",
    primary_700: "#083CA0",
    primary_800: "#083CA0",
    primary_900: "#081D4B",
    // secondary
    secondary_main: "#004C97",
    secondary_disabled: "#ccd7ed",
    secondary_50: "#D4EDFF",
    secondary_100: "#B2E0FF",
    secondary_200: "#D2C9E2",
    secondary_300: "#7DCFFF",
    secondary_400: "#148DFF",
    secondary_500: "#1677D8",
    secondary_600: "#0050FF",
    secondary_700: "#083CA0",
    secondary_800: "#083CA0",
    secondary_900: "#234168",
    // tertiary a
    tertiary_a_main: "#E1F0FF",
    tertiary_a_50: "#DFEAFA",
    tertiary_a_100: "#C6DBF7",
    tertiary_a_200: "#9CC2F1",
    tertiary_a_300: "#71A4E9",
    tertiary_a_400: "#5083E1",
    tertiary_a_500: "#3B67D5",
    tertiary_a_600: "#3254C3",
    tertiary_a_700: "#2E459F",
    tertiary_a_800: "#2A3E7E",
    tertiary_a_900: "#1E284D",
    // tertiary b
    tertiary_b_main: "#004C97",
    tertiary_b_50: "#D8E7FA",
    tertiary_b_100: "#C5DDF8",
    tertiary_b_200: "#9DC7F3",
    tertiary_b_300: "#6EA8EC",
    tertiary_b_400: "#4C88E5",
    tertiary_b_500: "#376CD9",
    tertiary_b_600: "#2E58C7",
    tertiary_b_700: "#2B49A2",
    tertiary_b_800: "#284080",
    tertiary_b_900: "#1D294E",
    // success
    success_main: "#22C55E",
    success_50: "#F0FDF5",
    success_100: "#FCE7F3",
    success_200: "#BBF7D1",
    success_300: "#86EFAD",
    success_400: "#4ADE80",
    success_500: "#22C55E",
    success_600: "#16A34A",
    success_700: "#15803C",
    success_800: "#166533",
    success_900: "#14532B",
    // warning
    warning_main: "#FFF5E1",
    warning_50: "#FFF8EB",
    warning_100: "#FFF8EB",
    warning_200: "#FDD28A",
    warning_300: "#FCBB4D",
    warning_400: "#FBAB24",
    warning_500: "#FFB600",
    warning_600: "#D98B06",
    warning_700: "#B47409",
    warning_800: "#92610E",
    warning_900: "#78510F",
    // error
    error_main: "#EF4444",
    error_50: "#FEE2E2",
    error_100: "#FECACA",
    error_200: "#FCA5A5",
    error_300: "#F87171",
    error_400: "#EF4444",
    error_500: "#DC2626",
    error_600: "#B91C1C",
    error_700: "#991B1B",
    error_800: "#7F1D1D",
    error_900: "#450A0A",
    // neutral
    neutral_50: "#F8F8F7",
    neutral_100: "#EFEFEF",
    neutral_200: "#DFE0DE",
    neutral_300: "#BCBFBA",
    neutral_400: "#989B95",
    neutral_500: "#5C5C5C",
    neutral_600: "#656861",
    neutral_700: "#52554F",
    neutral_800: "#464844",
    neutral_900: "#3C3F3B",
    // others
    background1: "#FFFFFF",
    background2: "#F3F3F3",
    border: "#B4B4B4",
    white: "#FFFFFF",
    black: "#101820",
    dark_medium: "#686A6A",
    gray_medium: "#6F7583",
    neutral_black: "#292E38",
    divider: "#D2D6DE",
    input_text_color: "#5C5C5C",
    select_option_color: "#5C5C5C",
    // Social media
    facebook: "#1877F2",
    google: "#DB4437",
    tooltip: {
      background: "#676A6A",
      text: "#FFFFFF"
    }
  },
  gradients: {
    landing_gradient: "linear-gradient(90deg, #234168 0%, #234168 61%, rgba(35, 65, 104, 0.65) 80%)",
    landing_gradient_mobile: "linear-gradient(0deg, #234168 0%, #234168 65%, rgba(35, 65, 104, 0.65) 100%)",
    carousel_gradient: "linear-gradient(90deg, #234168 22.5%, rgba(35, 65, 104, 0.44) 64%, rgba(102, 102, 102, 0) 100%)",
    // CONDITIONAL GRADIENTS SET HERE
    use_tertiary_gradients: false,
    tertiary_gradient: "linear-gradient(179.98deg, #1677D8 0.97%, #D86018 99.9%)"
    // CONDITIONAL GRADIENTS SET HERE
  },
  shadows: {
    card_shadows: "0px 2px 8px 0px rgba(50, 113, 195, 0.149)",
    flight_selection_card_shadow_1: "0px 4px 6px -1px #1018281A",
    flight_selection_card_shadow_2: "0px 2px 4px -2px #0000001A",
    generic_shadows: {
      shadow_1: "0px 2px 8px 0px #264D8026",
      shadow_2: "0px 2px 8px 0px #264D8026"
    }
  },
  textStyles: {
    h1_light: {
      fontSize: '40px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '48px'
    },
    h1_regular: {
      fontSize: '40px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '48px'
    },
    h1_medium: {
      fontSize: '40px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '48px'
    },
    h1_semiBold: {
      fontSize: '40px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '48px'
    },
    h1_bold: {
      fontSize: '40px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '48px'
    },
    h2_light: {
      fontSize: '36px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '44px'
    },
    h2_medium: {
      fontSize: '36px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '44px'
    },
    h2_regular: {
      fontSize: '36px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '44px'
    },
    h2_semiBold: {
      fontSize: '36px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '44px'
    },
    h2_bold: {
      fontSize: '36px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '44px'
    },
    h3_light: {
      fontSize: '32px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '40px'
    },
    h3_regular: {
      fontSize: '32px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '40px'
    },
    h3_medium: {
      fontSize: '32px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '40px'
    },
    h3_semiBold: {
      fontSize: '32px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '40px'
    },
    h3_bold: {
      fontSize: '32px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '40px'
    },
    h4_light: {
      fontSize: '28px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '36px'
    },
    h4_regular: {
      fontSize: '28px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '36px'
    },
    h4_medium: {
      fontSize: '28px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '36px'
    },
    h4_semiBold: {
      fontSize: '28px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '36px'
    },
    h4_bold: {
      fontSize: '28px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '36px'
    },
    h5_light: {
      fontSize: '24px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '32px'
    },
    h5_regular: {
      fontSize: '24px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '32px'
    },
    h5_medium: {
      fontSize: '24px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '32px'
    },
    h5_semiBold: {
      fontSize: '24px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '32px'
    },
    h5_bold: {
      fontSize: '24px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '32px'
    },
    h6_light: {
      fontSize: '20px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    h6_regular: {
      fontSize: '20px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    h6_medium: {
      fontSize: '20px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    h6_semiBold: {
      fontSize: '20px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    h6_bold: {
      fontSize: '20px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    plg_light: {
      fontSize: '18px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    plg_regular: {
      fontSize: '18px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    plg_medium: {
      fontSize: '18px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    plg_semiBold: {
      fontSize: '18px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    plg_bold: {
      fontSize: '18px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '28px'
    },
    pmd_light: {
      fontSize: '15px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '24px'
    },
    pmd_regular: {
      fontSize: '15px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '24px'
    },
    pmd_medium: {
      fontSize: '15px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '24px'
    },
    pmd_semiBold: {
      fontSize: '15px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '24px'
    },
    pmd_bold: {
      fontSize: '15px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '24px'
    },
    psm_light: {
      fontSize: '14px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    psm_regular: {
      fontSize: '14px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    psm_medium: {
      fontSize: '14px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    psm_semiBold: {
      fontSize: '14px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    psm_bold: {
      fontSize: '14px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    pxs_light: {
      fontSize: '12px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    pxs_regular: {
      fontSize: '12px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    pxs_medium: {
      fontSize: '12px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    pxs_semiBold: {
      fontSize: '12px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    pxs_bold: {
      fontSize: '12px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    pxxs_light: {
      fontSize: '10px',
      fontFamily: 'Inter',
      fontWeight: 300,
      letterSpacing: '0em',
      lineHeight: '15px'
    },
    pxxs_regular: {
      fontSize: '10px',
      fontFamily: 'Inter',
      fontWeight: 400,
      letterSpacing: '0em',
      lineHeight: '15px'
    },
    pxxs_medium: {
      fontSize: '10px',
      fontFamily: 'Inter',
      fontWeight: 500,
      letterSpacing: '0em',
      lineHeight: '15px'
    },
    pxxs_semiBold: {
      fontSize: '10px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '15px'
    },
    pxxs_bold: {
      fontSize: '10px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '15px'
    },
    overline_14: {
      fontSize: '14px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '20px'
    },
    overline_12: {
      fontSize: '12px',
      fontFamily: 'Inter',
      fontWeight: 700,
      letterSpacing: '0em',
      lineHeight: '20px'
    }
  },
  disclaimer: {
    iconStyle: "min-w-5 min-h-5",
    iconSize: 20,
    iconColor: "#1677D8",
    textStyle: "tx-psm-bold text-primary-main md:tx-pxs-semiBold",
    containerStyle: "relative inline-block cursor-pointer",
    tooltipBackgroundColor: "#676A6ACC"
  },
  chipDisclaimer: {
    backgroundColor: "#E1F0FF",
    textColor: "#004C97",
    iconColor: undefined,
    iconSize: 20,
    textStyle: "tx-psm-medium",
    iconStyle: "min-w-5 min-h-5",
    containerStyle: "w-full flex items-center justify-center",
    chipClassNameFlightDisplay: "rounded-lg"
  },
  informativeCard: {
    mode: "tooltip",
    deleteBorder: true,
    messageClass: 'tx-pxs-light',
    types: {
      infoTextColor: '#0F191E',
      infoBackgroundColor: '#F4F4F4'
    }
  }
};
export default APP_CONFIGURATION;